import {createNanoEvents} from 'nanoevents';
import type {Task} from '@/services/taskService';

export interface AwardEventData {
    level: number;
    totalLevels: number;
    completedTask: Task;
    newSuperpower: string;
    awardIcon?: 'shield' | 'guard' | 'print' | 'storage' | 'vision';
}

export interface AwardEvents {
    showAward: (data: AwardEventData) => void;
    hideAward: () => void;
}

export const awardEmitter = createNanoEvents<AwardEvents>();

// Утилиты для работы с событиями
export const awardEventActions = {
    showAward: (data: AwardEventData) => {
        awardEmitter.emit('showAward', data);
    },

    hideAward: () => {
        awardEmitter.emit('hideAward');
    },

    // Подписка на события
    onShowAward: (callback: (data: AwardEventData) => void) => {
        return awardEmitter.on('showAward', callback);
    },

    onHideAward: (callback: () => void) => {
        return awardEmitter.on('hideAward', callback);
    }
};

// Утилита для получения названия суперсилы по шагу
export const getSuperpowerByStep = (step: number): string => {
    const superpowers = [
        'Щит из реплик',
        'Великая печать секретов',
        'Взгляд Оракула',
        'Страж границ',
        'Хранитель равновесия'
    ];
    return superpowers[step - 1] || 'Неизвестная суперсила';
};

// Утилита для получения иконки по шагу
export const getIconByStep = (step: number): 'shield' | 'guard' | 'print' | 'storage' | 'vision' => {
    const icons: ('shield' | 'guard' | 'print' | 'storage' | 'vision')[] = [
        'shield',    // Щит из реплик
        'print',     // Автомасштабирование
        'storage',   // Балансировка нагрузки
        'guard',     // Секретное управление
        'vision'     // Мониторинг хаоса
    ];
    return icons[step - 1] || 'shield';
};
